import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {

  let defaultSchema: any = getValidationSchema([
    
    "industryId",
  ]);
  
  let customSchema = yup.object().shape({
    //add custom validation here
    name: yup
    .string()
    .trim("Designation cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "Designation must be more than 2 characters")
    .max(150, "Designation cannot exceed more than 150 characters")
    .matches(
      /^[a-zA-Z0-9].*[a-zA-Z0-9]$/,
      "Designation cannot start or end with a special character"
    )
    .matches(
      /^[a-zA-Z0-9 .,'&/-]+$/,
      "Designation can only contain letters, numbers, spaces, periods, commas, apostrophes, &, hyphens, and slashes"
    )
    .required("Designation is required"),
    
  });

  return defaultSchema.concat(customSchema);
};
